interface DurationIconProps {
  size?: number;
  color?: string;
}

/* Clock icon — matches Figma card footer (20×20, stroke #243B6B) */
const DurationIcon = ({ size = 20, color = "#243B6B" }: DurationIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="7.5" stroke={color} strokeWidth="1.4" />
    <path
      d="M10 6.25V10L12.5 12"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DurationIcon;
